// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__xrvyN","form":"style_form__tqgvf","input":"style_input__d5zGK","loginBtn":"style_loginBtn__hQIVz","bgImage":"style_bgImage__RhrlD"};